import { Redirect } from "react-router";
import * as EmailValidator from "email-validator";
import React, { Component, Fragment } from "react";
import NotificationSystem from "react-notification-system";
import { Col, Form, FormGroup, Label, Input, Button } from "reactstrap";

import PageSpinner from "../components/PageSpinner";

import "../styles/login.css";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

import * as Server from "../Server";
import * as GeneralFunctions from "../GeneralFunctions";

class AdminLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      isemail: "",
      ispassword: "",
      validEmail: false,
      showLoader: false,
    };
    this.shopToken = null;
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleChange = async (key, value) => {
    let obj = {
      [key]: value,
    };

    if (key === "email") {
      if (!obj.email.length) {
        this.setState({ isemail: "*Required" });
        this.setState({ validEmail: false });
      } else if (obj.email) {
        this.setState({ validEmail: await EmailValidator.validate(obj.email) });
        if (!this.state.validEmail) {
          this.setState({
            isemail: "*Please type valid email (test@email.com).",
          });
        } else this.setState({ isemail: "" });
      }
    }
    if (key === "password") {
      if (!obj.password.length) {
        this.setState({ ispassword: "*Required" });
      } else this.setState({ ispassword: " " });
    }
    this.setState(obj);
  };

  onSubmit = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "admin/login",
        method: "POST",
        data: {
          email: this.state.email,
          password: this.state.password,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        GeneralFunctions.setAuthUser(response.user);
        GeneralFunctions.setPermissions(response.user.role);
        GeneralFunctions.setAuthorizationHeader(response.token);
        switch (response.user.role) {
          case "admin":
            this.props.history.push("/mallProducts");
            break;
          case "rushAdmin":
            this.props.history.push("/events");
            break;
          case "jasklikadmin":
            this.props.history.push("/insurance");
            break;
          default:
            this.props.history.push("/adminList");
            break;
        }
        window.location.reload();
      }
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({ showLoader: false });
    }
  };

  render() {
    this.shopToken = localStorage.getItem("authorization");
    let disabled =
      this.state.ispassword === "" ||
      this.state.ispassword === "*Required" ||
      this.state.validEmail === false
        ? true
        : false;
    return (
      <Fragment>
        {this.shopToken ? (
          <Redirect to="/"></Redirect>
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <div className="login-form">
              <Form className="form" onSubmit={this.onSubmit}>
                <Col>
                  <h2>Admin Sign In</h2>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Username</Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      onChange={(event) => {
                        this.handleChange("email", event.target.value);
                      }}
                      placeholder="Enter your email"
                      required
                    />
                  </FormGroup>
                  <div>
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {this.state.isemail}
                    </p>
                  </div>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Password</Label>
                    <Input
                      id="password"
                      name="password"
                      type="password"
                      onChange={(event) => {
                        this.handleChange("password", event.target.value);
                      }}
                      placeholder="Enter your password"
                      required
                    />
                  </FormGroup>
                  <div>
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {this.state.ispassword}
                    </p>
                  </div>
                </Col>
                <Col>
                  <Button color="primary" type="submit" disabled={disabled}>
                    Login
                  </Button>
                </Col>
              </Form>
            </div>
            <NotificationSystem
              dismissible={false}
              ref={(notificationSystem) =>
                (this.notificationSystem = notificationSystem)
              }
              style={NOTIFICATION_SYSTEM_STYLE}
            />
          </div>
        )}
      </Fragment>
    );
  }
}

export default AdminLogin;
